export const emoteImages = [
  {
    src:'https://cdn.discordapp.com/emojis/1315746258320625674.webp?size=56&name=ta',
    alt:'ta'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1255446699371921428.webp?size=56',
    alt:'buh'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1391509265113550978.webp?size=56',
    alt:'o7'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1391509982486204496.webp?size=56',
    alt:'sus'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1391509060288774244.webp?size=56',
    alt:'um'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1391508964453384312.webp?size=56',
    alt:'aga'
  },
  {
    src:'https://cdn.discordapp.com/emojis/1391510441636790322.webp?size=56',
    alt:'Smile'
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813112310939779082.gif?size=56&name=pepeL',
    alt: 'pepeL',
  },
  {
    src:'https://cdn.discordapp.com/emojis/870246404172431423.webp?size=56&name=xqcL',
    alt:'xqcL'
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813112468032847922.gif?size=56&name=PepeLaugh',
    alt: 'PepeLaugh',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/890515834169073674.webp?size=56&name=GOTTEM',
    alt: 'GOTTEM',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/824884636295364619.png?size=56&name=sadKEK',
    alt: 'sadKEK',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/804595394185003018.gif?size=56&name=KEKBye',
    alt: 'KEKBye',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/862195358258692096.png?size=56&name=Prayge',
    alt: 'Prayge',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/597589606497648640.png?size=56&name=HandsUp',
    alt: 'HandsUp',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/844032585734684692.gif?size=56&name=gachiBASS',
    alt: 'gachiBASS',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813100210087133224.gif?size=56&name=gachiHYPER',
    alt: 'gachiHYPER',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/888544388844756992.png?size=56&name=Sadeg',
    alt: 'Sadeg',
  },
  {
    src: ' https://cdn.discordapp.com/emojis/782622316244369458.webp?size=56&name=Okayeg',
    alt: 'Okayeg',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/848800020891041812.png?size=56&name=Madeg',
    alt: 'Madeg',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/780571514063814676.webp?size=56&name=Ezeg',
    alt: 'Ezeg',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/852879438696939551.png?size=56&name=PepeHands',
    alt: 'PepeHands',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813101616626008085.gif?size=56&name=peepoClap',
    alt: 'peepoClap',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/862771446873587712.gif?size=56&name=pepeFlatline',
    alt: 'pepeFlatline',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/528713138657558538.gif?size=56&name=ppOverheat',
    alt: 'ppOverheat',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/820192787965673503.gif?size=56&name=pphop',
    alt: 'ppHop',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/824551728132390922.png?size=56&name=OkayBruh',
    alt: 'OkayBruh',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/944317493151952956.webp?size=56&name=Bruh',
    alt: 'Bruh',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/888543978377584670.png?size=56&name=dankHug',
    alt: 'dankHug',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/828143467376803890.gif?size=56&name=pepeAgony',
    alt: 'pepeAgony',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813098171567046656.png?size=56&name=monkaS',
    alt: 'monkaS',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/559816861810688030.png?size=56&name=NotLikeThis',
    alt: 'NotLikeThis',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/853142279892107265.webp?size=56&name=Jebaited',
    alt: 'Jebaited',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/876564694830284942.png?size=56&name=FeelsStrongMan',
    alt: 'FeelsStrongMan',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/952292295699464262.webp?size=56&name=FeelsBirthdayMan',
    alt: 'FeelsBirthdayMan',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813098171436630087.webp?size=56&name=FeelsBadMan',
    alt: 'FeelsBadMan',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/833931007224184873.gif?size=56&name=pepeW',
    alt: 'pepeW',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/867443504133308437.png?size=56&name=PepoG',
    alt: 'PepoG',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/657542129651810325.png?size=56&name=pepeHandRub',
    alt: 'pepeHandRub',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/507608818906300429.png?size=56&name=Pepega',
    alt: 'Pepega',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/939977229708976158.webp?size=56&name=pepeThink',
    alt: 'pepeThink',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/876567657141403678.png?size=56&name=Okayge',
    alt: 'Okayge',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/842879099424735262.gif?size=56&name=NODDERS',
    alt: 'NODDERS',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/862276176138862603.gif?size=56&name=NOPERS',
    alt: 'NOPERS',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/824776845760266270.png?size=56&name=NOP',
    alt: 'NOP',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/895785871012417586.webp?size=56&name=YEP',
    alt: 'YEP',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/952291392946835496.webp?size=56&name=Stare',
    alt: 'Stare',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/706909065032237158.png?size=56&name=BabyRage',
    alt: 'BabyRage',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/889909556115824660.webp?size=56&name=WudULookAtThat',
    alt: 'WudULookAtThat',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/888257811111370782.webp?size=56&name=NervousDog',
    alt: 'NervousDog',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/430731303042678784.webp?size=56&name=KKona',
    alt: 'KKona',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/898640058779852810.gif?size=56&name=ABDULPls',
    alt: 'ABDULPls',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/743559215418703924.png?size=56&name=lacFp',
    alt: 'lacFp',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/889032126622728192.png?size=56&name=Hmm',
    alt: 'Hmm',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/931969009111416832.webp?size=56&name=HUH',
    alt: 'HUH',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/882357725294641182.gif?size=56&name=dinkDonk',
    alt: 'dinkDonk',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/961101997522681906.webp?size=56&name=WeirdDude',
    alt: 'WeirdDude',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/658869217197686790.webp?size=56&name=EZ',
    alt: 'EZ',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/769647465203761222.gif?size=56&name=HACKERMANS',
    alt: 'HACKERMANS',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/813115043029581865.png?size=56&name=OMEGALUL',
    alt: 'OMEGALUL',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/888326165234872320.png?size=56&name=WICKED',
    alt: 'WICKED',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/518900729335775263.png?size=56&name=FeelsOkayMan',
    alt: 'FeelsOkayMan',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/890227504844009512.png?size=56&name=Bedge',
    alt: 'Bedge',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/838694084285169684.gif?size=56&name=GIGACHAD',
    alt: 'GIGACHAD',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/911979500231860265.webp?size=56&name=PogU',
    alt: 'PogU',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/808090431354568756.webp?size=56&name=forsenCD',
    alt: 'forsenCD',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/891461812632031272.gif?size=56&name=docArrive',
    alt: 'docArrive',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/811697790509776986.gif?size=56&name=docLeave',
    alt: 'docLeave',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/905851533625802782.gif?size=56&name=docCBT',
    alt: 'docCBT',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/758793359376121889.gif?size=56&name=DOCING',
    alt: 'DOCING',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/796320841959735297.gif?size=56&name=docPls',
    alt: 'docPls',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/800619559367081995.webp?size=56&name=Madge',
    alt: 'Madge',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/854371906378661902.webp?size=56&name=Sadge',
    alt: 'Sadge',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/699598474315825182.gif?size=56&name=PepegaAim',
    alt: 'PepegaAim',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/695566914658762814.gif?size=56&name=PepegaDriving',
    alt: 'PepegaDriving',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/644479444555137024.gif?size=56&name=peepoComfy',
    alt: 'peepoComfy',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/718071523088531487.gif?size=56&name=PETTHEPEEPO',
    alt: 'PETTHEPEEPO',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/644479444659994644.gif?size=56&name=pepeD',
    alt: 'pepeD',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/938556874243059782.webp?size=56&name=sadCatThumbsUp',
    alt: 'sadCatThumbsUp',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/933987854634324088.gif?size=56&name=FroggieDance',
    alt: 'FroggieDance',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/846826176252346368.gif?size=56&name=SadgeInRain',
    alt: 'SadgeInRain',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/378172287053987866.webp?size=56&name=TriHard7',
    alt: 'TriHard7',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/751068332035407954.gif?size=56&name=TriDance',
    alt: 'TriDance',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/930934801022742639.gif?size=56&name=Lamonting',
    alt: 'Lamonting',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/955305056046022766.webp?size=56&name=BASEDHALT',
    alt: 'BASEDHALT',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/934232154731327578.webp?size=56&name=BASED',
    alt: 'BASED',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/869060490968588359.webp?size=56&name=Wokege',
    alt: 'Wokege',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/881130642908274768.webp?size=56&name=BatChest',
    alt: 'BatChest',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/649731213740736542.webp?size=128&name=widepeepoHappy',
    alt: 'widepeepoHappy',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/649731240617967616.webp?size=128&name=WideHardo',
    alt: 'WideHardo',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/889031136532103260.webp?size=56&name=WiseHardo',
    alt: 'WiseHardo',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/819009993126445057.webp?size=56&name=4Head',
    alt: '4Head',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/855229134980513813.webp?size=48&name=4WeirdBuisness',
    alt: '4WeirdBuisness',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/895773833036955678.webp?size=56&name=4WeirdBuff',
    alt: '4WeirdBuff',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/579327223857807393.webp?size=56&name=5Head',
    alt: '5Head',
  },
  {
    src:'https://cdn.discordapp.com/emojis/772103198345265215.webp?size=48&name=Pog',
    alt:'Pog'
  },
  {
    src:'https://cdn.discordapp.com/emojis/559675737792184320.webp?size=56&name=PogChamp',
    alt:'PogChamp'
  },
  {
    src: 'https://cdn.discordapp.com/emojis/952291393357877249.gif?size=56&name=peepoHey',
    alt: 'peepoHey',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/952291393622143026.webp?size=56&name=peepoBlush',
    alt: 'peepoBlush',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/939987275461308416.webp?size=56&name=peepoHeart',
    alt: 'peepoHeart',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/755831395204464650.gif?size=56&name=peepoCrySwim',
    alt: 'peepoCrySwim',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/919626183824515162.webp?size=48&name=Clueless',
    alt: 'Clueless',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/674223391749701633.webp?size=56&name=Wot',
    alt: 'Wot',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/674223306580295681.webp?size=56&name=Derp',
    alt: 'Derp',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/674223354038976522.webp?size=56&name=Angry',
    alt: 'Angry',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/952766861009883197.webp?size=56&name=GrumpyPingu',
    alt: 'GrumpyPingu',
  },
  {
    src:'https://cdn.discordapp.com/emojis/796647947521622036.webp?size=56&name=KomodoHype',
    alt:'KomodoHype'
  },
  {
    src: 'https://cdn.discordapp.com/emojis/882365536409894912.webp?size=56&name=forsenDespair',
    alt: 'forsenDespair',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/873110087806373898.png?size=64&name=WutfaceW',
    alt: 'WutfaceW',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/926105437219221504.gif?size=56&name=Bateman',
    alt: 'Bateman',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/876567406548500551.webp?size=56&name=arnoldHalt',
    alt: 'arnoldHalt',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/859748272900800562.webp?size=56&name=PogO',
    alt: 'PogO',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/833980171006509086.gif?size=56&name=MadgeHyperSalami',
    alt: 'MadgeHyperSalami',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/806711007908855829.webp?size=56&name=COPIUM',
    alt: 'COPIUM',
  },

  {
    src: 'https://cdn.discordapp.com/emojis/970503387521122344.webp?size=56&name=Sniff',
    alt: 'Sniff',
  },
  {
    src:'https://cdn.discordapp.com/emojis/742833216595034133.gif?size=56&name=GiveEmTheLove',
    alt:'GiveEmTheLove'
  }
];
export const notFoundImages = [
  {
    src: 'https://cdn.discordapp.com/emojis/852879438696939551.png?size=56',
    alt: 'PepeHands',
  },
  {
    src: 'https://cdn.discordapp.com/emojis/559816861810688030.png?size=56',
    alt: 'NotLikeThis',
  },
];
